import { DEFAULT_DATA_FILL_COLOR, DEFAULT_DATA_FONT_COLOR } from "../config";
import { YieldType } from "../globalTypes";
import { DATA_PRODUCER_WORKSHEET_NAME } from "../globalValues";
import { ASK_IDX, BID_IDX, DATA_PRODUCER_TABLE_NAME, QUOTE_FEED_IDX } from "./constants";
import { uploadButtonInactiveStyles } from "./processDataProducerEvent/utils";

interface GetCellFromTableArgs {
  table: Excel.Table;
  index: number;
  row: number;
}

const getCellFromTable = ({ table, index, row }: GetCellFromTableArgs) => {
  return table.columns.getItemAt(index).getRange().getCell(row, 0);
};

export const resetStylesForDataSentSuccessfully = async ({
  sendedRow,
  yieldToReset,
}: {
  sendedRow: number;
  yieldToReset: YieldType;
}) => {
  await Excel.run(async (context) => {
    const row = sendedRow - 1;

    const worksheet = context.workbook.worksheets.getItem(DATA_PRODUCER_WORKSHEET_NAME);
    const table = worksheet.tables.getItemOrNullObject(DATA_PRODUCER_TABLE_NAME);

    const quoteFeedCell = getCellFromTable({ table, index: QUOTE_FEED_IDX, row });
    const askCell = getCellFromTable({ table, index: ASK_IDX, row });
    const bidCell = getCellFromTable({ table, index: BID_IDX, row });
    const cellToReset = yieldToReset === YieldType.ASK ? askCell : bidCell;

    const cellsToReset = [quoteFeedCell, cellToReset];

    for (const cell of cellsToReset) {
      cell.format.fill.color = DEFAULT_DATA_FILL_COLOR;
      cell.format.font.color = DEFAULT_DATA_FONT_COLOR;
    }

    uploadButtonInactiveStyles(table, row);

    await context.sync();
  });
};
